// extracted by mini-css-extract-plugin
export default {"innerWrapper":"FC-z","tooltipWrapper":"GC-z","icon":"HC-z","tooltip":"IC-z","content":"JC-z"};